import { atom } from 'jotai';
import { PolygonProps } from '@abyss/3d-viewer';
import {
  DataLoaderPointOfInterestQueryObject,
  BlisterToAdd,
  EditPointOfInterest,
  PointOfInterestQuery,
  PointOfInterestTemplateDocument,
} from '@/types';

export const poiFilteredByCheckbox = atom<PointOfInterestQuery>([]);

export const selectedPointOfInterestId = atom<string | undefined>(undefined);

export const editPointOfInterest = atom<EditPointOfInterest>({ state: 'Inactive' });

export const blisterToAdd = atom<BlisterToAdd | undefined>(undefined);

export const structurePois = atom<DataLoaderPointOfInterestQueryObject>([]);

export const blisterPolygons = atom<PolygonProps[] | undefined>(undefined);

export const manualBlisterHeightExists = atom<boolean>(false);

export const selectedTemplate = atom<PointOfInterestTemplateDocument | undefined>(undefined);

export const defectsList = atom<Array<{ key: string; value: string }>>([]);
